<div class="mat-elevation-z3 " style="padding: 16px">
    <dx-data-grid #datagriddx
                [dataSource]="gridDataSource"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [style]="style"
                (onToolbarPreparing)="onToolbarPreparing($event)">
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-editing mode="row"
                    [allowUpdating]="false"
                    [allowAdding]="false"
                    [useIcons]="true">
        </dxo-editing>
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxi-column dataField="Code" caption="{{languageService.LNG('Label.TimeType')}}" [width]="100"></dxi-column>
        <dxi-column dataField="StartTimeTommss" caption="{{languageService.LNG('Label.Start')}}" [width]="70" alignment="right"></dxi-column>
        <dxi-column dataField="StopTimeTommss" caption="{{languageService.LNG('Label.Stop')}}" [width]="70" alignment="right"></dxi-column>
        <dxi-column dataField="SecondsToHHmm" [cellTemplate]="timeCellTemplate" caption="{{languageService.LNG('Label.Hours.Minutes.Short')}}" [width]="70" alignment="right"></dxi-column>
        <dxi-column dataField="Project" caption="{{languageService.LNG('Label.Project')}}"></dxi-column>
        <div *dxTemplate="let data of 'headerTitle'">
                <span style="font-size: 20px;" >{{this.headerTitle}}</span>
        </div>
    </dx-data-grid>
</div>
